import { render, staticRenderFns } from "./PreOrderModal.vue?vue&type=template&id=3996ca60"
import script from "./PreOrderModal.vue?vue&type=script&lang=js"
export * from "./PreOrderModal.vue?vue&type=script&lang=js"
import style0 from "./PreOrderModal.vue?vue&type=style&index=0&id=3996ca60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports